import { Component } from 'react';
import { Result, Button } from 'antd';

export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (import.meta.env.DEV) {
      console.error('App crashed:', error, info);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <Result
          status="500"
          title="Something went wrong"
          subTitle={this.state.error.message ?? 'Unexpected error.'}
          extra={
            <Button type="primary" onClick={() => window.location.assign('/')}>
              Reload
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}
